import React, { Component } from 'react'
import PropTypes from 'prop-types'

class LegendSection extends Component {

	constructor(){
		super();

	}

	clickHandler(){

		this.props.clickFunc();
	}
	render() {
	
		if( this.props.color) {
			var iconStyle = { float: 'left', margin: '5px', borderRadius: '1em', backgroundColor: this.props.color, height: '1.2em', width:'1.2em', radius: '1em'};
		} else if (this.props.stripes) {
			var direction = this.props.stripes === 'horizontal' ? 'to bottom' : 'to right';
			var iconStyle = {
				float: 'left', 
				margin: '5px', 
				borderRadius: '1em',
				background: 'repeating-linear-gradient(' + direction + ', rgb(255, 255, 255), rgb(255, 255, 255) 1px, rgb(156, 156, 156) 1px, rgb(156, 156, 156) 4px)',
				height: '1.2em', width:'1.2em', radius: '1em'};

				console.log('iconStyle', iconStyle);
		}
		
		if(this.props.border)
		{
			iconStyle = Object.assign(iconStyle, {border: this.props.border })
		}

	    return (
	    	<div>
		        <div style={iconStyle}></div><div style={{float:'left', padding: '5px', maxWidth: '92%'}}>{this.props.text}</div>
		     	<div style={{clear:'both'}}></div>
	      	</div>
	   	);
	}
}

LegendSection.propTypes = {
	color: PropTypes.string,
	text: PropTypes.string
};

export {LegendSection};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/legend/section.js